module.exports = __webpack_public_path__ + "img/mypic2023.4c59f692.jpg";